// Pure calendar utility functions shared between rental widget components
// TODO: When calendar grid CSS duplication becomes painful, extract CalendarGrid.vue

export function buildCalCells(year, month, firstDayOfWeek) {
    const first = new Date(year, month, 1)
    const firstDow = (first.getDay() - firstDayOfWeek + 7) % 7
    const daysInMonth = new Date(year, month + 1, 0).getDate()
    const prevDaysInMonth = new Date(year, month, 0).getDate()
    const cells = []
    for (let i = 0; i < firstDow; i++) {
        cells.push({ d: new Date(year, month - 1, prevDaysInMonth - firstDow + i + 1), out: true })
    }
    for (let i = 1; i <= daysInMonth; i++) {
        cells.push({ d: new Date(year, month, i), out: false })
    }
    let nextDay = 1
    while (cells.length % 7 !== 0) {
        cells.push({ d: new Date(year, month + 1, nextDay++), out: true })
    }
    return cells
}

export function sameDay(a, b) {
    return a && b &&
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate()
}

export function toYMD(d) {
    const y = d.getFullYear()
    const m = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    return `${y}-${m}-${dd}`
}

export function getCalCellClass(cell, {
    hoveredDate = null,
    selectedDates = null,
    blockedStartDays = new Set(),
    blockedEndDays = new Set(),
    busyDaysData = {},
    rangeContainsBlockedIntersect = () => false,
} = {}) {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const d = cell.d
    const s = selectedDates?.start ? new Date(selectedDates.start) : null
    const e = selectedDates?.end ? new Date(selectedDates.end) : null
    const effectiveEnd = e || (s && hoveredDate ? hoveredDate : null)

    let inRange = false
    if (s && effectiveEnd) {
        const min = s <= effectiveEnd ? s : effectiveEnd
        const max = s <= effectiveEnd ? effectiveEnd : s
        inRange = d > min && d < max
    }

    const isPickingStart = !s || (s && e)
    const isPickingEnd = !!(s && !e)
    const isBlockedEnd = isPickingEnd && d > s && (
        blockedEndDays.has(d.getDay()) || rangeContainsBlockedIntersect(s, d)
    )

    return {
        'rw-cal-cell': true,
        'out': cell.out,
        'disabled': d < today,
        'blocked-start': !cell.out && d >= today && isPickingStart && blockedStartDays.has(d.getDay()),
        'blocked-end': !cell.out && d >= today && isBlockedEnd,
        'range-start': !cell.out && s && sameDay(d, s) && !(e && sameDay(d, e)),
        'range-end': !cell.out && e && sameDay(d, e) && !(s && sameDay(d, s)),
        'range-single': !cell.out && s && e && sameDay(d, s) && sameDay(d, e),
        'in-range': inRange && !(s && sameDay(d, s)) && !(e && sameDay(d, e)),
        'today': !cell.out && sameDay(d, today),
        'busy-full': !cell.out && busyDaysData[toYMD(d)] === 'full',
        'busy-partial': !cell.out && busyDaysData[toYMD(d)] === 'partial',
    }
}
